import React from "react";
import data from "../assets/categories.json";

const Categories = ({ onSelectCategory }) => {
  const categories = data.categories;

  return (
    <section id="categories" className="py-12 bg-white" aria-label="Furniture Categories — Geetha Furniture Coimbatore">
      <h2 className="text-4xl font-bold text-center mb-8">Browse Popular Categories</h2>

      <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto px-4">
        {categories.map((cat) => (
          <div
            key={cat.id}
            onClick={() => onSelectCategory(cat.id)}
            className="cursor-pointer w-[45%] sm:w-[45%] md:w-[22%] rounded-lg shadow-lg hover:scale-105 transition-transform bg-white"
            role="button"
            aria-label={`View ${cat.name} — Geetha Furniture Coimbatore`}
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && onSelectCategory(cat.id)}
          >
            {/* Square image container */}
            <div className="w-full aspect-square overflow-hidden rounded-t-lg flex items-center justify-center bg-white">
              <img
                src={process.env.PUBLIC_URL + cat.image}
                alt={`${cat.name} — Geetha Furniture Coimbatore`}
                loading="lazy"
                className="w-full h-full object-contain p-2"
              />
            </div>
            <div className="p-3 text-center font-semibold">{cat.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Categories;
